import * as angular from 'angular';
import { config } from 'angular/utils/config';
import { XmlUploader } from '../custom';

export interface PortfolioCodeAssignmentResource
    extends
        ng.resource.IResourceClass<ng.resource.IResource<PortfolioCodeDto>>,
        XmlUploader {
    get: ng.resource.IResourceMethod<
        ng.resource.IResource<PortfolioCodeAssignmentDto>
    >;
    generateXml: ng.resource.IResourceMethod<
        ng.resource.IResource<FallbackUploadResponseDto>
    >;
    uploadAsXML: ng.resource.IResourceMethod<
        ng.resource.IResource<FallbackUploadResponseDto>
    >;
    save: ng.resource.IResourceMethod<
        ng.resource.IResource<PortfolioCodeAssignmentDto>
    >;
}

function portfolioCodeAssignmentResource(
    $resource: ng.resource.IResourceService
): PortfolioCodeAssignmentResource {
    return <PortfolioCodeAssignmentResource>$resource(
        config.monolithApi + '/portfolio-code-assignment',
        {},
        {
            get: {
                method: 'GET',
                url: config.monolithApi + '/portfolio-code-assignment/:name'
            },
            generateXml: {
                method: 'POST',
                url: config.monolithApi + '/portfolio-code-assignment/as-xml'
            },
            uploadAsXML: {
                method: 'POST',
                url: config.monolithApi + '/portfolio-code-assignment',
                transformRequest: angular.identity,
                headers: { 'Content-Type': undefined }
            }
        }
    );
}

angular
    .module('app')
    .factory(
        'portfolioCodeAssignmentResource',
        portfolioCodeAssignmentResource
    );
